import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=c15993d6&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=js&"
export * from "./Tips.vue?vue&type=script&lang=js&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=c15993d6&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15993d6",
  null
  
)

export default component.exports